import * as React from 'react'

function SvgCarKeyUnchecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m29 12.414-2.293 2.293-1.414-1.414L27.586 11l-2.293-2.293 1.414-1.414L29 9.586l2.293-2.293 1.414 1.414L30.414 11l2.293 2.293-1.414 1.414L29 12.414Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path d="M11 19a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.692 17.004h1.603a9.033 9.033 0 0 0 2.584 2H21v2h1.586l.707-.708a1 1 0 0 1 1.154-.187l1.356.677.49-.49a1 1 0 0 1 1.154-.187l1.235.617.52-.728a8.98 8.98 0 0 0 2.71-.48.997.997 0 0 1-.155.34l-1.943 2.725a1 1 0 0 1-1.261.315l-1.355-.678-.49.49a1 1 0 0 1-1.155.188l-1.355-.678-.49.49a1 1 0 0 1-.708.293h-2.31c-.565 1.42-1.845 2.453-3.383 2.578l-5 .406C9.984 26.177 8 24.236 8 21.775v-3.55c0-2.46 1.984-4.401 4.307-4.212l5 .406c1.54.125 2.822 1.161 3.385 2.585Zm-3.539-.479-5-.406c-1.161-.095-2.153.876-2.153 2.106v3.55c0 1.23.992 2.2 2.153 2.106l5-.406C18.195 23.39 19 22.472 19 21.369v-2.74c-.001-1.103-.805-2.02-1.847-2.104Z"
      />
    </svg>
  )
}

export default SvgCarKeyUnchecked
